import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HistorialCambiosService {
  private apiUrl = `${environment.apiUrl}/api/historial-cambios`;

  constructor(private http: HttpClient) { }

  // Crear un nuevo historial de cambios
  createHistorial(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, data);
  }

  // Obtener todos los historiales de cambios
  getAllHistoriales(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }

  // Obtener un historial de cambios por ID
  getHistorialById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  // Obtener todos los historiales de cambios por documento_id
  getHistorialByDocumento(documentoId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/documento/${documentoId}`);
  }

  // Actualizar un historial de cambios por ID
  updateHistorial(id: number, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, data);
  }

  // Eliminar un historial de cambios por ID
  deleteHistorial(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}